import { Helmet } from "react-helmet-async";

const STEPS = ["Customer Details", "Shipping", "Payment", "Confirmation"];

export default function Checkout() {
  return (
    <>
      <Helmet><title>Checkout | Cool Wave</title></Helmet>
      <section className="container py-14">
        <h1 className="mb-6 text-3xl font-bold">Checkout</h1>
        <ol className="mb-10 flex flex-wrap items-center gap-4 text-sm">
          {STEPS.map((s, i) => (
            <li key={s} className="flex items-center gap-2">
              <span className="flex h-7 w-7 items-center justify-center rounded-full bg-brand-50 text-xs font-semibold text-brand">{i + 1}</span>
              <span className="text-body">{s}</span>
            </li>
          ))}
        </ol>
        <div className="rounded-xl border border-dashed border-border p-10 text-center text-body">
          Checkout flow is wired up but inactive — payment provider is being connected.
        </div>
      </section>
    </>
  );
}
